import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-acesso',
    templateUrl: './acesso.component.html',
    styleUrls: ['./acesso.component.scss'],
    standalone: false
})
export class AcessoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
